import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgCalendar = function SvgCalendar(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#calendar_svg__clip0)"
  }, React.createElement("path", {
    d: "M20.31 3.063h-.32V7.04a3 3 0 11-5.999 0V3.063H9.995V7.04a3 3 0 01-5.999 0V3.063h-.305C1.65 3.063 0 4.854 0 7.059v12.974c0 2.21 1.65 3.996 3.69 3.996h16.62c2.04 0 3.69-1.791 3.69-3.996V7.059c0-2.205-1.66-3.996-3.69-3.996zM6.506 21.017a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-5.496a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.514v-.014zm5.49 5.496a1.5 1.5 0 110-2.999 1.5 1.5 0 010 3zm0-5.496a1.5 1.5 0 111.5-1.5 1.501 1.501 0 01-1.5 1.514v-.014zm5.506 5.496a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0-5.496a1.5 1.5 0 111.5-1.5 1.5 1.5 0 01-1.5 1.514v-.014z"
  }), React.createElement("path", {
    d: "M7.01 8.042a1.001 1.001 0 001-1.002V1.041a1.001 1.001 0 00-1.997 0v6a1.001 1.001 0 00.996 1zM17.004 8.042a1.001 1.001 0 001.002-1.002V1.041a1.002 1.002 0 10-1.998 0v6a1.001 1.001 0 00.996 1z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "calendar_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgCalendar;